module.exports = __webpack_public_path__ + "static/media/img-01.aab5b2cd.jpg";